<template>
    <div class="page fx fx-c_stretch" v-loading="loading" element-loading-text="页面加载中..." @click="tabMenu.show=false">
        <div class="left_panel fx-col">
            <div class="fx fx-center">
                <img v-if="config.id" :src="config.logo ? config.logo : require('../assets/logo.png')" class="logo">
            </div>
            <div class="navs fx-g1">
                <MenuNav></MenuNav>
            </div>
        </div>
        <div class="right_panel fx-col fx-g1">
            <div class="head fx fx-m_between fx-c_center">
                <div class="fx fx-center font16">
                    <i class="func_icon iconfont icon-xitong font20"></i>
                    <span class="func_title">{{user.institutionName}}</span>
                </div>
                <div class="fx fx-center">
                    <span class="el-dropdown" style="margin-right: 30px;cursor: pointer;" @click="lessonSeries"
                        v-if="infoEnable">
                        <i class="iconfont icon-banji1"></i>课程包
                    </span>
                    <span class="el-dropdown" style="margin-right: 30px;cursor: pointer;" @click="agentInfo"
                        v-if="infoEnable">
                        <i class="iconfont icon-warning-circle"></i>系统升级
                    </span>
                    <span class="el-dropdown" style="margin-right: 30px;cursor: pointer;" @click="schoolHelp">
                        <i class="iconfont icon-play-circle"></i>使用指导
                    </span>

                    <el-avatar class="avatar" size="large" :src="user.avatar"></el-avatar>
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link user_name">
                            {{user.name}} <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-switch-button" command="logOut">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="body fx-g1 fx fx-c_stretch">
                <el-tabs :value="currentTab" type="card" closable @tab-click="activeTab" @tab-remove="closeTab"
                    class="fx-g1 fx-col fx-c_stretch main_tabs">
                    <el-tab-pane v-for="(item, i) in tabs" :key="item.name" :name="item.name">
                        <span slot="label" class="main_tabs-item"
                            @click.right.stop.prevent="showTabMenu(item, i)">{{item.title}}</span>
                        <component :is="item.page" :attr="item.attr" class="fx-g1"></component>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <div class="tab_menu" v-show="tabMenu.show" :style="`top:${tabMenu.top}px;left:${tabMenu.left}px`">
            <div @click="closeOtherTabs(tabMenu.currentTab)">关闭其他</div>
            <div @click="closeAllTabs">关闭所有</div>
            <div @click="closeLeftTabs(tabMenu.currentIndex)">关闭左侧</div>
            <div @click="closeRightTabs(tabMenu.currentIndex)">关闭右侧</div>
        </div>

    </div>
</template>

<style scoped>
    .tab_menu {
        position: fixed;
        left: 240px;
        top: 108px;
        width: 128px;
        background: white;
        box-shadow: 0 2px 10px rgba(0, 0, 0, .12), 0 0 20px rgba(0, 0, 0, .04);
        z-index: 2000;
        border-radius: 4px;
        padding: 5px 0;
    }

    .tab_menu>div {
        height: 30px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }

    .tab_menu>div:hover {
        background: var(--primary);
        color: white;
    }

    .left_panel {
        width: 220px;
        background: #344040;
    }

    .left_panel .logo {
        max-width: 100%;
        max-height: 85px;
    }

    .navs {
        margin-top: 10px;
    }

    .right_panel {
        background: #E5E5E5;
    }

    .head {
        height: 60px;
        background: white;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 0 45px;
    }

    .head .func_icon {
        color: var(--primary);
    }

    .head .avatar {
        margin-right: 10px;
    }

    .head .user_name {
        font-size: 16px;
    }

    .body {
        margin: 8px;
        overflow: hidden;
    }

    .body>div.panel {
        /*animation: movein 1.2s; */
        /*animation-fill-mode: forwards;*/
    }

    /*@keyframes movein { 妈了个蛋的，就这个代码 elementui也能出问题，日了狗了*/
    /*    from {*/
    /*        !*transform: translateX(2000px);*!*/
    /*        opacity: 0;*/
    /*    }*/
    /*    to {*/
    /*        !*transform: translateX(0);*!*/
    /*        opacity: 1;*/
    /*    }*/

    /*}*/
</style>


<script>
    import MenuNav from '@/components/MenuNav.vue'

    import {
        mapState,
        mapMutations
    } from "vuex";


    export default {
        components: {
            MenuNav,
        },
        props: [],
        data() {
            return {
                loading: true,
                tabMenu: {
                    show: false,
                    left: 0,
                    top: 0,
                    currentTab: null,
                    currentIndex: 0,
                },
                config: {},
                infoEnable: false,
            }

        },

        computed: {
            ...mapState({
                page: state => state.currentPage,
                user: state => state.user,
                tabs: state => state.tabs,
                currentTab: state => state.currentTab
            })
        },

        methods: {
            ...mapMutations([
                "reLogin",
                "setToken",
                "activeTab",
                "closeTab",
                'openTab',
                "setNavs",
                "closeOtherTabs",
                "closeAllTabs",
                "closeLeftTabs",
                "closeRightTabs",
            ]),
            handleCommand(command) {
                if (command == "logOut") {
                    this.logOut();
                }
            },
            logOut() {
                this.$showConfirm("确认退出吗？", () => {
                    this.$ajaxGet("/login/out");
                    this.reLogin();
                })
            },
            showTabMenu(tab, index) {
                this.tabMenu = {
                    show: true,
                    left: event.pageX,
                    top: event.pageY,
                    currentTab: tab,
                    currentIndex: index
                }
            },

            loadFunctionTree() {
                this.$ajaxGet("/function/userFunctionTree", (data) => {
                    //在这里先过滤掉按钮页面
                    const oldList =JSON.parse(JSON.stringify(data.result));
                    let newList = [];
                    data.result.forEach((item, index) => {
                        if (item.children) {
                            let children=[];
                            item.children.forEach((item1,index1)=>{
                                if(item1.funcType != 6){
                                    children.push(item1);
                                }
                            });
                            item.children= children;
                        }
                        newList.push(item);
                    })
                    let all = {
                        bigList: oldList, //过滤前
                        smallList: newList //过滤后
                    }
                    this.setNavs(all);
                    this.loading = false;
                    this.openTab({
                        funcKey: "school_menu_home",
                        name: "首页",
                        allowDuplicate: false,
                    })
                })
            },
            loadConfig() {
                this.$ajaxGet("/institution/getSelfInfo", data => {
                    this.config = data.result;
                })
            },
            schoolHelp() {
                this.openTab({
                    funcKey: "school_menu_guide",
                    title: "使用指导",
                    allowDuplicate: true
                });
            },
            agentInfo() {
                window.open("?type=systemUpgrade");
                //this.openTab({
                //    funcKey: "school_menu_agent_info",
                //    title: "系统升级",
                //    allowDuplicate: true
                //});
            },
            lessonSeries() {
                window.open("?type=lessonSeries");
                //this.openTab({
                //    funcKey: "school_page_lesson_series",
                //    title: "课程包",
                //    allowDuplicate: true
                //});
            },
            loadSchoolExpire() { //检测是否到了到期提醒
                this.$ajaxGet("/institution/doSchoolExpire", data => {
                    if (data.result) {
                        let schoolExpira = localStorage.getItem("schoolExpira");
                        if (!schoolExpira) {
                            localStorage.setItem("schoolExpira", true);
                            this.$alert('您的校区即将' + data.result + '在到期，请及时续费', '友情提示', {
                                confirmButtonText: '确定',
                            });
                        }
                    }
                })
            },
            loadAgentInfoEnable() {
                this.$ajaxGet("/agencyInfo/getInfoBySelf", data => {
                    if (data.result) {
                        this.infoEnable = data.result.enable;
                    }
                })
            },
        },
        created() {
            this.loadSchoolExpire();
            //this.loadFunctionTree();
            this.loadConfig();
            this.loadAgentInfoEnable();
        },
        beforeDestroy() {

        },
        mounted() {
            this.loadFunctionTree();
        }
    }
</script>
